import "./ContactHero.css";
import { useState, useEffect } from "react";
import { useTranslation } from "../i18n";

function ContactHero() {
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile(); // Verifica al cargar

        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return (
        <>
            {isMobile ? (
                <>
                    <div id="contact-hero" className="contact-hero">
                        <div className="overlay"></div>
                        <div className="contact-hero-content">
                        <h2>{t("contact.heroKicker")}</h2>
                        <h1>{t("contact.heroTitleMobile")}</h1>
                        <p>
                            {t("contact.heroP1Mobile")}
                        </p>
                        <p>
                            {t("contact.heroP2Mobile")}
                        </p>
                        <a href="#contact-form" className="contact-button">{t("contact.talk")}</a>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div id="contact-hero" className="contact-hero">
                        <div className="overlay"></div>
                        <div className="contact-hero-content">
                        <h2>{t("contact.heroKicker")}</h2>
                        <h1>{t("contact.heroTitle")}</h1>
                        <p>
                            {t("contact.heroP1")}
                        </p>
                        <p>
                            {t("contact.heroP2")}
                        </p>
                        <a href="#contact-form" className="contact-button">{t("contact.talk")}</a>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default ContactHero;
